import PropTypes from 'prop-types';
import FJMenuTab from '../../../../common/components/FJMenuTab/FJMenuTab';
import FJAppLeft from '../../../FJMainPreview/FJAppLeft/FJAppLeft';
import FJPhotoRemoveBgCustomLeftContainer from '../container/FJPhotoRemoveBgCustomLeftContainer';
import FJPhotoRemoveBgAutoLeftContainer from '../container/FJPhotoRemoveBgAutoLeftContainer';
import { MENU_LIST } from '../../../../redux/slices/FJSlicePhotoBgRemover';
import styles from './FJPhotoRemoveBgLeft.module.less';

const FJPhotoRemoveBgLeft = props => {
    const { curMenuIndex, switchCurMenuIndex, isShowMenu = true } = props;

    return (
        <FJAppLeft className={styles.app_left}>
            {isShowMenu && <FJMenuTab list={MENU_LIST} curIndex={curMenuIndex} onChange={switchCurMenuIndex} />}

            <FJPhotoRemoveBgAutoLeftContainer isShow={curMenuIndex === 0} />

            <FJPhotoRemoveBgCustomLeftContainer isShow={curMenuIndex === 1} />
        </FJAppLeft>
    );
};

FJPhotoRemoveBgLeft.propTypes = {
    curMenuIndex: PropTypes.number,
    switchCurMenuIndex: PropTypes.func,
    isShowMenu: PropTypes.bool,
};

export default FJPhotoRemoveBgLeft;
